import { render, staticRenderFns } from "./accessory.vue?vue&type=template&id=630e5603&scoped=true&"
import script from "./accessory.vue?vue&type=script&lang=js&"
export * from "./accessory.vue?vue&type=script&lang=js&"
import style0 from "./accessory.vue?vue&type=style&index=0&id=630e5603&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e5603",
  null
  
)

export default component.exports